const SUBMISSION_STATUS_LABELS = {
  succeeded: 'Succeeded',
  failed: 'Failed',
  canceled: 'Canceled',
};

export default function getSubmissionStatusLabel(status) {
  return SUBMISSION_STATUS_LABELS[status] || 'Unknown';
}
